import React from "react";

import { SkeletonPlaceholder } from "src/base-components/SkeletonPlaceholder";
import { CaseActionsConfigurationStep } from "src/cases/templates/CaseActionsConfigurationStep";
import { CaseBlocksConfigurationStep } from "src/cases/templates/CaseBlocksConfigurationStep";
import { ConfigureFileCategoriesStep } from "src/cases/templates/ConfigureFileCategoriesStep";
import { DefineCasePropertiesStep } from "src/cases/templates/DefineCasePropertiesStep";
import { DefineTasksStep } from "src/cases/templates/DefineTasksStep";
import { DefineVersionSettingsStep } from "src/cases/templates/DefineVersionSettingsStep";
import { DefineWorkflowRulesStep } from "src/cases/templates/DefineWorkflowRulesStep";
import { FormStepWrapper } from "src/cases/templates/FormStepWrapper";
import { getStepById, useCurrentStep } from "src/cases/templates/formSteps";
import { SelectDecisionFlowStep } from "src/cases/templates/SelectDecisionFlowStep";

export const CaseTemplateFormRouter: React.FC<{
  isLoading: boolean;
}> = ({ isLoading }) => {
  const [currentStepId] = useCurrentStep();

  if (isLoading) {
    const step = getStepById(currentStepId);

    return (
      <FormStepWrapper description={step.description} title={step.title}>
        <SkeletonPlaceholder height="h-5" width="w-110" />
        <SkeletonPlaceholder height="h-5" width="w-118" />
        <SkeletonPlaceholder height="h-5" width="w-96" />
        <SkeletonPlaceholder height="h-5" width="w-110" />
        <SkeletonPlaceholder height="h-5" width="w-96" />
      </FormStepWrapper>
    );
  }

  switch (currentStepId) {
    case "define-version-settings":
      return <DefineVersionSettingsStep />;
    case "define-case-properties":
      return <DefineCasePropertiesStep />;
    case "configure-file-categories":
      return <ConfigureFileCategoriesStep />;
    case "select-decision-flow":
      return <SelectDecisionFlowStep />;
    case "configure-case-actions":
      return <CaseActionsConfigurationStep />;
    case "define-tasks":
      return <DefineTasksStep />;
    case "define-workflow-rules":
      return <DefineWorkflowRulesStep />;
    case "configure-case-blocks":
      return <CaseBlocksConfigurationStep />;
    default:
      return <div>Default content</div>;
  }
};
